import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Organisation } from '@futrli-sdk/organisations';

import { SyncControl, SyncControlProps } from './sync-control';
import { UpdateFromExcelOrganisationDrawer } from '../update-from-excel-organisation-drawer';

interface SyncControlExcelProps
  extends Omit<SyncControlProps, 'dataSyncedMessage' | 'onReconnect' | 'onSyncNow' | 'syncNowMessage'> {
  organisation: Organisation;
  workspaceId: string;
}

export const SyncControlExcel = ({ organisation, workspaceId, ...props }: SyncControlExcelProps) => {
  const dataSyncedMessage = <FormattedMessage id="import.excel_last_uploaded" defaultMessage="Excel last uploaded" />;
  const syncNowMessage = <FormattedMessage id="datasource.update_values" defaultMessage="Update values" />;

  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const handleReconnect = () => {
    // never happens for excel files, so just stub this out
  };

  const handleUploadExcelValuesClick = () => setIsOpenDrawer(true);

  const handleUploadExcelValuesClose = () => setIsOpenDrawer(false);

  return (
    <>
      <SyncControl
        {...props}
        onReconnect={handleReconnect}
        onSyncNow={handleUploadExcelValuesClick}
        dataSyncedMessage={dataSyncedMessage}
        syncNowMessage={syncNowMessage}
      />
      <UpdateFromExcelOrganisationDrawer
        isOpen={isOpenDrawer}
        onClose={handleUploadExcelValuesClose}
        organisation={organisation}
        workspaceId={workspaceId}
      />
    </>
  );
};
